import { createTabsModule } from './features/tabs';

export const wbMetricTabs = createTabsModule({
  state: {
    tabs: [],

    tab: 0,
  },
});
